(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(()=>{
 document.addEventListener('click',event=>{
  const summary=event.target.closest('.nav-dropdown>summary,.mobile-nav-group>summary');
  if(summary){const group=summary.parentElement;group.parentElement.querySelectorAll('details[open]').forEach(other=>{if(other!==group)other.open=false;});}
  if(!event.target.closest('.desktop-nav'))document.querySelectorAll('.nav-dropdown[open]').forEach(el=>el.open=false);
 });
 document.addEventListener('focusin',event=>{document.querySelectorAll('.nav-dropdown[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});});
 document.addEventListener('keydown',event=>{if(event.key==='Escape'){const group=event.target.closest('.nav-dropdown,.mobile-nav-group');if(group){group.open=false;group.querySelector('summary').focus();}}});
})();

  } catch(e) { console.error(e); }
})();
})();
